import api from '../index';

const baseUrl = '/communication';

export const getCustomersApi = (query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/customer-chats?limit=${query?.limit}&page=${
      query?.page || 0
    }&search=${query?.search || ''}&searchType=${query?.searchType || 'all'}`,
  });
};

export const getCustomersChatsApi = (customerId, query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/chats/${customerId}?limit=${query?.limit}&page=${
      query?.page || 0
    }&search=${query?.searchValue || ''}&searchType=${
      query?.selectedType || ''
    }`,
  });
};

export const sendMessageApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/send-message`,
    data,
  });
};

export const readMessagesApi = (customerId) => {
  return api({
    method: 'post',
    url: `${baseUrl}/read-messages/${customerId}`,
  });
};

export const pinMessagesApi = (customerId, data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/pin-messages/${customerId}`,
    data,
  });
};

export const getCustomerData = (customerId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/customer/${customerId}`,
  });
};

export const deleteMessagesApi = (customerId) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete-messages/${customerId}`,
  });
};

// unread msgs count
export const getUnrReadMsgsCountApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/un-read-messages-count`,
  });
};

// customers count
export const getTotalCustomersCount = (query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/customers-count?search=${query?.search || ''}&searchType=${
      query?.searchType || ''
    }`,
  });
};

//  msgs count
export const getTotalMsgsCountApi = (customerId, query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/messages-count/${customerId}?search=${
      query?.searchValue || ''
    }&searchType=${query?.selectedType || ''}`,
  });
};
